module.exports = __webpack_public_path__ + "static/media/Headshot.68ea74ba.jpeg";